export default "__VITE_ASSET__kO36xcSB__"